/* Publish by EComposer at 2025-08-05 21:26:10*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-urhnxgm5k4"]=  window.__ectimmers["ecom-urhnxgm5k4"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),o=e.querySelector(".text-content.ecom-html");!o||(i&&i.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-urhnxgm5k4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urhnxgm5k4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nzscxfbn3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nzscxfbn3o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vstf0qpjxop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vstf0qpjxop', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mpd5pfozpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mpd5pfozpa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kd11ce3cskm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kd11ce3cskm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ka9i30p46h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ka9i30p46h', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}